import { Dispatch } from 'redux';
import { typedAction } from 'store/modules/base';
import {
  OperacaoCompraVendaRequest,
  OperacaoCompraVendaResponse,
  OperacaoOfertaPrimariaRequest,
  OperacaoOfertaPrimariaResponse,
  AddInteroperabilidadeRequest,
  OperacaoInteroperabilidadeResponse,
  GETOperacoesFilterParams,
  GETComprasVendasFilterParams,
  CompraVendaResumoResponse,
  CompraVendaDocumento,
  TransferenciaRequest,
  OperacaoTransferenciaResponse,
  TransferenciaCustodiaResponse,
  TransferenciaCustodiaRequest,
  CommandResult,
  PaginatedResult,
  TransferenciaResumoResponse,
  GETTransferenciasResumoFilterParams,
  TransferenciaInteroperabilidadeRequest,
  SolicitacaoInteroperabilidadeResult,
  CommandResultTyped,
  Comprovante,
  ComprovanteInvestidorResponse,
  CancelamentoQuantidadesRequest,
  OperacaoCompraVendaCompromissadaResponse,
  OperacaoCompraVendaCompromissadaRequest,
  TipoLiquidacao,
  ApproveOfertaPrimariaRequest,
  CancelarAlterarAgendamentoRequest,
  AgendamentoMovimentacao,
} from 'common/genericTypes';
import {
  GETOperacoesCompraVenda,
  GETOperacaoCompraVendaDetalhes,
  GETOperacoesInteroperabilidade,
  GETOperacoesOfertaPrimaria,
  GETOperacoesTransferencia,
  POSTTransferenciasResumoPaginated,
  GETOperacaoTransferencia,
  GETOperacaoOfertaPrimariaDetalhes,
  GETAgendamentosOfertaPrimaria,
  POSTAceitarCompraVenda,
  POSTAprovarOfertaPrimaria,
  POSTConfirmarLiquidacaoCompraVenda,
  POSTOperacaoCompraVenda,
  POSTOperacaoOfertaPrimaria,
  POSTOperacoesCompraVenda,
  POSTOperacoesTransferencia,
  POSTTransferenciaCustodia,
  POSTRejeitarCompraVenda,
  POSTCancelarCompraVenda,
  POSTReprovarOfertaPrimaria,
  PUTTransferenciaDocument,
  PUTTransferenciaCustodiaDocuments,
  POSTTransferenciaInteroperabilidade,
  PUTTransferenciaInteroperabilidadeDocuments,
  GETInteroperabilidadeDocumentDownloadUrl,
  PUTAprovarTransferenciaInteroperabilidade,
  PUTRecusarTransferenciaInteroperabilidade,
  POSTTransferenciaInteroperabilidadeEntrada,
  POSTTransferenciaInteroperabilidadeSaida,
  GETOfertaPrimariaComprovanteDownloadUrl,
  POSTCancelarQuantidades,
  GETOperacoesOfertaPrimariaPaginated,
  POSTOfertasPrimariasRelatorioCompleto,
  POSTComprovanteInvestidorById,
  GETComprovantesInvestidor,
  GETComprovanteInvestidorDownloadUrl,
  GetOperacoesCompraVendaCompromissada,
  POSTOperacaoCompraCompromissadaVenda as POSTOperacaoCompraVendaCompromissada,
  POSTOperacaoOfertaPrimariaCriarELiquidar,
  POSTLiquidarOfertaPrimaria,
  PUTAgendamentoOfertaPrimaria,
  POSTComprasVendasPaginated,
  POSTComprasVendasRelatorioCompleto,
  POSTComprasVendasCompromissadasPaginated,
  GETCompraVendaDocumentos,
  POSTUploadCompraVendaDocumento,
} from 'requests/operacao';

export interface OperacaoApiState {
  getOperacaoOfertaPrimariaDetalhes(
    dispatch: Dispatch,
    operacaoId: string,
    stackRequest?: boolean
  ): Promise<OperacaoOfertaPrimariaResponse>;
  postOperacaoOfertaPrimaria(
    dispatch: Dispatch,
    instrumentoId: string,
    operacaoOfertaPrimariaRequest: OperacaoOfertaPrimariaRequest,
    stackRequest?: boolean
  ): Promise<OperacaoOfertaPrimariaResponse>;
  getOperacaoCompraVendaDetalhes(
    dispatch: Dispatch,
    operacaoId: string,
    stackRequest?: boolean
  ): Promise<OperacaoCompraVendaResponse>;
  postOperacaoCompraVenda(
    dispatch: Dispatch,
    instrumentoId: string,
    operacoesCompraVendaRequest: Array<OperacaoCompraVendaRequest>,
    stackRequest?: boolean
  ): Promise<Array<OperacaoCompraVendaResponse>>;
  postOperacaoCompraVendaCompromissada(
    dispatch: Dispatch,
    instrumentoId: string,
    operacoesCompraVendaCompromissadaRequest: Array<OperacaoCompraVendaCompromissadaRequest>,
    stackRequest?: boolean
  ): Promise<Array<OperacaoCompraVendaCompromissadaResponse>>;
  getOperacoesInteroperabilidade(
    dispatch: Dispatch,
    stackRequest?: boolean
  ): Promise<Array<OperacaoInteroperabilidadeResponse>>;
  postOperacoesInteroperabilidadeEntrada(
    dispatch: Dispatch,
    body: AddInteroperabilidadeRequest,
    stackRequest?: boolean
  ): Promise<any>;
  postOperacoesInteroperabilidadeSaida(
    dispatch: Dispatch,
    body: AddInteroperabilidadeRequest,
    stackRequest?: boolean
  ): Promise<any>;
  getOperacoesOfertaPrimaria(
    dispatch: Dispatch,
    params?: GETOperacoesFilterParams,
    stackRequest?: boolean
  ): Promise<Array<OperacaoOfertaPrimariaResponse>>;
  getOperacoesOfertaPrimariaPaginated(
    dispatch: Dispatch,
    filter?: GETOperacoesFilterParams,
    stackRequest?: boolean
  ): Promise<PaginatedResult<OperacaoOfertaPrimariaResponse>>;
  postOfertasPrimariasRelatorioCompleto(
    dispatch: Dispatch,
    filter?: GETOperacoesFilterParams,
    stackRequest?: boolean
  ): Promise<Array<OperacaoOfertaPrimariaResponse>>;
  postAprovarOfertaPrimaria(
    dispatch: Dispatch,
    operacaoId: string,
    comprovantes?: Array<Comprovante>,
    stackRequest?: boolean
  ): Promise<OperacaoOfertaPrimariaResponse>;
  postReprovarOfertaPrimaria(
    dispatch: Dispatch,
    operacaoId: string,
    stackRequest?: boolean
  ): Promise<OperacaoOfertaPrimariaResponse>;
  getOperacoesCompraVenda(
    dispatch: Dispatch,
    params?: GETOperacoesFilterParams,
    stackRequest?: boolean
  ): Promise<Array<OperacaoCompraVendaResponse>>;
  postComprasVendasPaginated(
    dispatch: Dispatch,
    filter?: GETComprasVendasFilterParams,
    stackRequest?: boolean
  ): Promise<PaginatedResult<CompraVendaResumoResponse>>;
  postComprasVendasRelatorioCompleto(
    dispatch: Dispatch,
    filter?: GETComprasVendasFilterParams,
    stackRequest?: boolean
  ): Promise<Array<CompraVendaResumoResponse>>;
  postComprasVendasCompromissadasPaginated(
    dispatch: Dispatch,
    filter?: GETComprasVendasFilterParams,
    stackRequest?: boolean
  ): Promise<PaginatedResult<CompraVendaResumoResponse>>;
  getOperacoesCompraVendaCompromissada(
    dispatch: Dispatch,
    params?: GETOperacoesFilterParams,
    stackRequest?: boolean
  ): Promise<Array<OperacaoCompraVendaCompromissadaResponse>>;
  postAceitarCompraVenda(
    dispatch: Dispatch,
    operacaoId: string,
    stackRequest?: boolean
  ): Promise<OperacaoCompraVendaResponse>;
  postRejeitarCompraVenda(
    dispatch: Dispatch,
    operacaoId: string,
    justificativa: string,
    stackRequest?: boolean
  ): Promise<OperacaoCompraVendaResponse>;
  postCancelarCompraVenda(
    dispatch: Dispatch,
    operacaoId: string,
    justificativa: string,
    stackRequest?: boolean
  ): Promise<OperacaoCompraVendaResponse>;
  postConfirmarLiquidacaoCompraVenda(
    dispatch: Dispatch,
    operacaoId: string,
    precoUnitario?: number,
    stackRequest?: boolean
  ): Promise<OperacaoCompraVendaResponse>;
  postOperacoesCompraVenda(
    dispatch: Dispatch,
    id: string,
    operacoesCompraVendaRequest: Array<OperacaoCompraVendaRequest>,
    stackRequest?: boolean
  ): Promise<Array<OperacaoCompraVendaResponse>>;
  postOperacoesTransferencia(
    dispatch: Dispatch,
    instrumentoId: string,
    body: TransferenciaRequest,
    stackRequest?: boolean
  ): Promise<OperacaoTransferenciaResponse>;
  putTransferenciaDocument(
    dispatch: Dispatch,
    operacaoId: string,
    transferenciaId: string,
    file: File,
    stackRequest?: boolean
  ): Promise<any>;
  postTransferenciaCustodia(
    dispatch: Dispatch,
    body: TransferenciaCustodiaRequest,
    stackRequest?: boolean
  ): Promise<CommandResult>;
  putTransferenciaCustodiaDocuments(
    dispatch: Dispatch,
    transferenciaId: string,
    files: Array<File>,
    stackRequest?: boolean
  ): Promise<any>;
  getOperacoesTransferencia(dispatch: Dispatch, stackRequest?: boolean): Promise<Array<OperacaoTransferenciaResponse>>;
  getTransferenciasResumoPaginated(
    dispatch: Dispatch,
    filter?: GETTransferenciasResumoFilterParams,
    stackRequest?: boolean
  ): Promise<PaginatedResult<TransferenciaResumoResponse>>;
  getOperacaoTransferencia(
    dispatch: Dispatch,
    transferenciaId: string,
    stackRequest?: boolean
  ): Promise<OperacaoTransferenciaResponse>;
  postTransferenciaInteroperabilidade(
    dispatch: Dispatch,
    body: TransferenciaInteroperabilidadeRequest,
    stackRequest?: boolean
  ): Promise<CommandResultTyped<SolicitacaoInteroperabilidadeResult>>;
  putTransferenciaInteroperabilidadeDocuments(
    dispatch: Dispatch,
    transferenciaId: string,
    files: Array<File>,
    stackRequest?: boolean
  ): Promise<any>;
  getInteroperabilidadeDocumentDownloadUrl(
    dispatch: Dispatch,
    interoperabilidadeId: string,
    documentId: string,
    stackRequest?: boolean
  ): Promise<{ data: string }>;
  putAprovarTransferenciaInteroperabilidade(
    dispatch: Dispatch,
    interoperabilidadeId: string,
    stackRequest?: boolean
  ): Promise<any>;
  putRecusarTransferenciaInteroperabilidade(
    dispatch: Dispatch,
    interoperabilidadeId: string,
    justificativa: string,
    stackRequest?: boolean
  ): Promise<any>;
  getOfertaPrimariaComprovanteDownloadUrl(
    dispatch: Dispatch,
    ofertaPrimariaId: string,
    comprovanteId: string,
    stackRequest?: boolean
  ): Promise<string>;
  postCancelarQuantidades(
    dispatch: Dispatch,
    request: CancelamentoQuantidadesRequest,
    stackRequest?: boolean
  ): Promise<any>;
  postOperacaoOfertaPrimariaCriarELiquidar(
    dispatch: Dispatch,
    operacaoOfertaPrimariaRequest: OperacaoOfertaPrimariaRequest,
    stackRequest?: boolean
  ): Promise<OperacaoOfertaPrimariaResponse>;
    getCompraVendaDocumentos(
    dispatch: Dispatch,
    operacaoId: string,
    stackRequest?: boolean
  ): Promise<Array<CompraVendaDocumento>>;
  postUploadCompraVendaDocumento(
    dispatch: Dispatch,
    compraVendaId: string,
    arquivo: File,
    stackRequest?: boolean
  ): Promise<any>;
  postLiquidarOfertaPrimaria(
    dispatch: Dispatch,
    operacaoId: string,
    request: ApproveOfertaPrimariaRequest,
    stackRequest?: boolean
  ): Promise<OperacaoOfertaPrimariaResponse>;
  putAgendamentoOfertaPrimaria(
    dispatch: Dispatch,
    request: CancelarAlterarAgendamentoRequest,
    stackRequest?: boolean
  ): Promise<OperacaoOfertaPrimariaResponse>;
  getAgendamentosOfertaPrimaria(
    dispatch: Dispatch,
    operacaoId: string,
    stackRequest?: boolean
  ): Promise<Array<AgendamentoMovimentacao>>;
  postComprovanteInvestidorById(
    dispatch: Dispatch,
    operacaoId: string,
    investidorId: string,
    files: File[],
    stackRequest?: boolean
  ): Promise<void[]>;
  getComprovantesInvestidor(
    dispatch: Dispatch,
    operacaoId: string,
    investidorId: string,
    stackRequest?: boolean
  ): Promise<Array<ComprovanteInvestidorResponse>>;
  getComprovanteInvestidorDownloadUrl(
    dispatch: Dispatch,
    operacaoId: string,
    investidorId: string,
    comprovanteId: string,
    stackRequest?: boolean
  ): Promise<string>;
}

const operacaoApiInitialState: OperacaoApiState = {
  getOperacaoOfertaPrimariaDetalhes: GETOperacaoOfertaPrimariaDetalhes,
  postOperacaoOfertaPrimaria: POSTOperacaoOfertaPrimaria,
  getOperacaoCompraVendaDetalhes: GETOperacaoCompraVendaDetalhes,
  postOperacaoCompraVenda: POSTOperacaoCompraVenda,
  postOperacaoCompraVendaCompromissada: POSTOperacaoCompraVendaCompromissada,
  getOperacoesInteroperabilidade: GETOperacoesInteroperabilidade,
  getOperacoesOfertaPrimaria: GETOperacoesOfertaPrimaria,
  getOperacoesOfertaPrimariaPaginated: GETOperacoesOfertaPrimariaPaginated,
  postOfertasPrimariasRelatorioCompleto: POSTOfertasPrimariasRelatorioCompleto,
  postAprovarOfertaPrimaria: POSTAprovarOfertaPrimaria,
  postReprovarOfertaPrimaria: POSTReprovarOfertaPrimaria,
  getOfertaPrimariaComprovanteDownloadUrl: GETOfertaPrimariaComprovanteDownloadUrl,
  getOperacoesCompraVenda: GETOperacoesCompraVenda,
  postComprasVendasPaginated: POSTComprasVendasPaginated,
  postComprasVendasRelatorioCompleto: POSTComprasVendasRelatorioCompleto,
  postComprasVendasCompromissadasPaginated: POSTComprasVendasCompromissadasPaginated,
  getOperacoesCompraVendaCompromissada: GetOperacoesCompraVendaCompromissada,
  postAceitarCompraVenda: POSTAceitarCompraVenda,
  postRejeitarCompraVenda: POSTRejeitarCompraVenda,
  postCancelarCompraVenda: POSTCancelarCompraVenda,
  postConfirmarLiquidacaoCompraVenda: POSTConfirmarLiquidacaoCompraVenda,
  postOperacoesCompraVenda: POSTOperacoesCompraVenda,
  postOperacoesTransferencia: POSTOperacoesTransferencia,
  putTransferenciaDocument: PUTTransferenciaDocument,
  getOperacoesTransferencia: GETOperacoesTransferencia,
  getTransferenciasResumoPaginated: POSTTransferenciasResumoPaginated,
  getOperacaoTransferencia: GETOperacaoTransferencia,
  postTransferenciaCustodia: POSTTransferenciaCustodia,
  putTransferenciaCustodiaDocuments: PUTTransferenciaCustodiaDocuments,
  postOperacoesInteroperabilidadeEntrada: POSTTransferenciaInteroperabilidadeEntrada,
  postOperacoesInteroperabilidadeSaida: POSTTransferenciaInteroperabilidadeSaida,
  postTransferenciaInteroperabilidade: POSTTransferenciaInteroperabilidade,
  putTransferenciaInteroperabilidadeDocuments: PUTTransferenciaInteroperabilidadeDocuments,
  getInteroperabilidadeDocumentDownloadUrl: GETInteroperabilidadeDocumentDownloadUrl,
  putAprovarTransferenciaInteroperabilidade: PUTAprovarTransferenciaInteroperabilidade,
  putRecusarTransferenciaInteroperabilidade: PUTRecusarTransferenciaInteroperabilidade,
  postCancelarQuantidades: POSTCancelarQuantidades,
  postOperacaoOfertaPrimariaCriarELiquidar: POSTOperacaoOfertaPrimariaCriarELiquidar,
  getCompraVendaDocumentos: GETCompraVendaDocumentos,
  postUploadCompraVendaDocumento: POSTUploadCompraVendaDocumento,
  postLiquidarOfertaPrimaria: POSTLiquidarOfertaPrimaria,
  putAgendamentoOfertaPrimaria: PUTAgendamentoOfertaPrimaria,
  getAgendamentosOfertaPrimaria: GETAgendamentosOfertaPrimaria,
  postComprovanteInvestidorById: POSTComprovanteInvestidorById,
  getComprovantesInvestidor: GETComprovantesInvestidor,
  getComprovanteInvestidorDownloadUrl: GETComprovanteInvestidorDownloadUrl,
};

enum OperacaoApiActionType {
  Update = 'api/UPDATE',
  Reset = 'api/RESET',
}

export const updateOperacaoApi = (state: OperacaoApiState) => {
  return typedAction(OperacaoApiActionType.Update, state);
};

export const resetOperacaoApi = () => {
  return typedAction(OperacaoApiActionType.Reset);
};

type OperacaoApiAction = ReturnType<typeof updateOperacaoApi | typeof resetOperacaoApi>;

export function operacaoApiReducer(
  state: OperacaoApiState = operacaoApiInitialState,
  action: OperacaoApiAction
): OperacaoApiState {
  switch (action.type) {
    case OperacaoApiActionType.Update:
      return { ...action.payload };
    case OperacaoApiActionType.Reset:
      return { ...operacaoApiInitialState };
    default:
      return state;
  }
}
